<template>
  <b-container>
    <!-- <b-row> -->
      <b-row>
        Введите название станции в поле или кликните на карте
      </b-row>
    <b-row>
      <OptionPicker
        optionID="wmo_id"
        :disabled="false"
        :available-options="availableOptions"
        :on-option-click="onOptionClick"
        :on-remove-tag="removeTag"
        :find-text="'Поиск станции по имени'"
        option-label="Имя метеостанции"
        :selected-stations-names="selectedStationsNames"/>

    </b-row>

    <b-row>
        <b-button class="w-100 mt-2" size="sm" @click="getEventsByStations" :disabled="selectedStationsNames.length===0"> Показать список опасных явлений</b-button>
    </b-row>

    <b-modal id="modal-stations-builder" title="Опасные явления по выбранным станциям" size="xl" ok-only>
        <graphic-builder-stations></graphic-builder-stations>
    </b-modal>

  </b-container>
</template>

<script>
import GraphicBuilderStations from './GraphicBuilderStations'
import OptionPicker from '@/components/OptionPicker.vue'
export default {
  name: 'stations-picker',
  data () {
    return {
      selectedStation: '',
      search: ''
    }
  },
  computed: {
    aviableStations () {
      return this.$store.getters.GET_STATIONS
    },
    stationsNames () {
      return this.$_.map(this.aviableStations, 'name').sort()
    },
    selectedStationsNames () {
      return this.$store.getters.GET_SELECTED_STATIONS_NAMES
    },
    criteria () {
      // Compute the search criteria
      return this.search.trim().toLowerCase()
    },
    availableOptions () {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.aviableStations.filter(opt => this.selectedStationsNames.indexOf(opt.name) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.name.toLowerCase().indexOf(criteria) > -1)
      }
      // Show all options available
      return this.$_.sortBy(options, 'name')
    },
    searchDesc () {
      if (this.criteria && this.availableOptions.length === 0) {
        return 'Нет ни одной станции по вашему запросу'
      }
      return ''
    }
  },
  methods: {
    addStationByName () {
      // this.selectedStationsNames.push(this.selectedStation)
      this.$store.commit('ADD_WMO_NAME', this.selectedStation)
    },
    clearSelectedStationsNames () {
      // this.selectedStationsNames.push(this.selectedStation)
      this.$store.commit('CLEAR_SELECTED_WMOS')
    },
    async getEventsByStations () {
      await this.$store.dispatch('LOAD_EVENTS_BY_STATIONS_NAME')
      this.$bvModal.show('modal-stations-builder')
    },
    onOptionClick ({ option, addTag }) {
      addTag((option.name))
      this.$store.commit('ADD_WMO_NAME', option.name)
      this.search = ''
    },
    removeTag (tag) {
      this.$store.commit('REMOVE_WMO_NAME', tag)
    }
  },
  mounted () {
    // console.log('mounted')
    this.$store.commit('SET_GEOJSON_CLICK', true)
  },
  components: {
    OptionPicker,
    GraphicBuilderStations
  }

}
</script>

<style>

</style>
